import makeStyles from '@material-ui/core/styles/makeStyles';
import { format } from 'date-fns';

const useStyles = makeStyles(() => ({
    btn: {
        display: 'inline-block',
        padding: '5px 12px',
        fontSize: '14px',
        color: '#00a3f9',
        background: 'none',
        border: '1px solid #00a3f9',
        borderRadius: 12,
        cursor: 'pointer',

        '&:hover': {
            borderColor: 'rgba(255,255,255,.15)',
            color: '#ffce01'
        }
    }
}))

const columns = [
    { id: 'update_date', label: 'Дата обновления'},
    { id: 'user_id', label: 'ID'},
    { id: 'login', label: 'Логин'},
    { id: 'wincoin', label: 'WINCOIN'},
    { id: 'level', label: 'Уровень'}
];

const getRows = (data) => {
    return data.map((item) => {
            return {
                user_id: item.user_id,
                login: item.login,
                wincoin: item.wincoin,
                level: item.level,
                update_date: item?.update_at ? format(new Date(Number(item.update_at)), 'dd.MM.yyyy HH:mm') : '-'
            }
    })
}

export {
    useStyles,
    columns,
    getRows
}